import { Navigate, Outlet } from 'react-router-dom';
import { useAdminAuth } from '@/context/AdminAuthContext';

/**
 * Wraps protected admin routes.
 * Shows a loading spinner while token is being validated,
 * then redirects to login if not authenticated.
 */
export default function ProtectedAdminRoute() {
    const { user, loading } = useAdminAuth();

    if (loading) {
        return (
            <div className="min-h-screen bg-[#060d1f] flex items-center justify-center">
                <div className="flex flex-col items-center gap-4">
                    <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-accent-500 to-primary-600 flex items-center justify-center shadow-xl animate-pulse">
                        <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                    </div>
                    <div className="space-y-2 text-center">
                        <div className="w-32 h-2 bg-white/10 rounded-full overflow-hidden">
                            <div className="h-full bg-gradient-to-r from-accent-500 to-primary-500 rounded-full animate-shimmer"
                                style={{ backgroundSize: '200% auto' }} />
                        </div>
                        <p className="text-xs text-slate-500 tracking-widest uppercase">Authenticating…</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/adminpanel/login" replace />;
    }

    return <Outlet />;
}
